export default __webpack_public_path__ + "2474aa6a7ad0e6bd46d865bcca349cad.png";